import * as React from "react";
import { SelectComponentsProps } from "react-select/src/Select";
import SmartSelectBaseFilter from "../../../core/models/SmartSelectBaseFilter";
import includes from "lodash/includes";
import { SelectOptions } from "../../../core/models/SelectOptions";
import Select from "react-select";
import { createStyles, FormControl, makeStyles, Theme } from "@material-ui/core";
import useConstructor from "../../../core/hooks/useConstructor";
import { EVENT_DARK_MODE } from "../../../Events";
import { LocalCache } from "../../../helpers/cache";
import { useHubXSubscribe } from "../../../HubX";
type SmartSelectProps = SmartSelectBaseFilter & SelectComponentsProps;
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      background: theme.customPaper.background.cardBackgroundLight,
    },
  })
);
function customSelectFilter(
  candidate: { label: string; value: string; data: SelectOptions },
  input: string
) {
  if (input) {
    return Boolean(
      includes(candidate.value.toLocaleLowerCase(), input.toLocaleLowerCase()) ||
        includes(candidate.data?.name?.toLocaleLowerCase(), input.toLocaleLowerCase())
    );
  }
  return true;
}

function SmartSelect({
  options,
  getOptionLabel,
  value,
  onChange,
  isMulti,
  ...others
}: SmartSelectProps) {
  const [isDark, setIsDark] = React.useState(false);
  const classes = useStyles();

  const CARD_BACKGROUND_DARK = "#424242";
  const CARD_BACKGROUND_ULTRA_DARK = "rgb(48, 48, 48)";
  const CARD_BACKGROUND_WHITE = "#FFF";

  const lcache = new LocalCache();

  const getFromCache = () => {
    const prefersDark = lcache.get<boolean>("prefersDarkMode") || false;
    setIsDark(prefersDark);
  };

  useConstructor(async () => {
    getFromCache();
  });

  useHubXSubscribe(EVENT_DARK_MODE, (isDark: boolean) => {
    setIsDark(isDark);
  });

  const defaultMenu = {
    menu: (provided: any, state: any) => ({
      ...provided,
      background: isDark ? CARD_BACKGROUND_ULTRA_DARK : CARD_BACKGROUND_WHITE,
      zIndex: 1498,
    }),
    menuPortal: (provided: any) => ({
      ...provided,
      zIndex: 1498,
    }),
  };

  const darkMode = isDark
    ? {
        ...defaultMenu,
        control: (styles: any, state: any) => {
          return {
            ...styles,
            "backgroundColor": isDark ? CARD_BACKGROUND_ULTRA_DARK : CARD_BACKGROUND_WHITE,

            "borderColor": isDark ? CARD_BACKGROUND_ULTRA_DARK : CARD_BACKGROUND_WHITE,
            ":hover": {
              // backgroundColor: isDark ? CARD_BACKGROUND_DARK : CARD_BACKGROUND_WHITE,
              borderColor: isDark ? CARD_BACKGROUND_ULTRA_DARK : CARD_BACKGROUND_WHITE,
              boxShadow: `0 0 1px ${isDark ? CARD_BACKGROUND_ULTRA_DARK : CARD_BACKGROUND_WHITE} `,
            },
            "& .css-b8ldur-Input, .css-1g6gooi, .css-1uccc91-singleValue": {
              color: isDark ? "#fff !important" : "#000 !important",
            },
          };
        },
        option: (styles: any, state: any) => ({
          ...styles,
          "backgroundColor": isDark ? CARD_BACKGROUND_ULTRA_DARK : CARD_BACKGROUND_WHITE,
          ":hover": {
            backgroundColor: isDark ? CARD_BACKGROUND_DARK : CARD_BACKGROUND_WHITE,
            borderColor: isDark ? CARD_BACKGROUND_ULTRA_DARK : CARD_BACKGROUND_WHITE,
          },
        }),
        clearIndicator: (styles: any, state: any) => ({
          ...styles,
          backgroundColor: isDark ? CARD_BACKGROUND_ULTRA_DARK : CARD_BACKGROUND_WHITE,
        }),
        multiValue: (provided: any, state: any) => {
          return {
            ...provided,
            "backgroundColor": isDark ? CARD_BACKGROUND_DARK : CARD_BACKGROUND_WHITE,
            "& .css-12jo7m5": {
              color: isDark ? "#fff !important" : "#000 !important",
            },
            "& .css-b8ldur-Input, .css-1g6gooi": {
              color: isDark ? "#fff !important" : "#000 !important",
            },
          };
        },
        value: (provided: any, state: any) => {
          return {
            ...provided,
            "backgroundColor": isDark ? CARD_BACKGROUND_DARK : CARD_BACKGROUND_WHITE,
            "& .css-12jo7m5": {
              color: isDark ? "#fff !important" : "#000 !important",
            },
            "& .css-b8ldur-Input, .css-1g6gooi": {
              color: isDark ? "#fff !important" : "#000 !important",
            },
          };
        },
      }
    : defaultMenu;
  const customSelectStyles = {
    /* eslint-disable @typescript-eslint/no-explicit-any */
    container: (provided: any, state: any) => ({
      minWidth: 300,
      maxHeight: 120,
      overflow: "auto",
      ...provided,
    }),
    ...darkMode,
  };
  /* eslint-enable @typescript-eslint/no-explicit-any */

  return (
    <Select
      className={classes.root}
      isMulti={isMulti ?? true}
      isClearable
      isSearchable
      options={options}
      getOptionLabel={getOptionLabel}
      filterOption={customSelectFilter}
      value={value}
      onChange={onChange}
      styles={customSelectStyles}
      menuPortalTarget={document.body}
      menuPosition="fixed"
      noOptionsMessage={() => "Nenhuma outra opção"}
      loadingMessage={() => "Carregando..."}
      placeholder="Selecione..."
      {...others}
    />
  );
}

export default SmartSelect;
